var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiread7b"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiread7b"] = parcelRequire;
}
const $5c1e54a0c01efb07$export$65d22f7a770a927c = "There was a problem getting the requested information from the server. Please try again.";
const $5c1e54a0c01efb07$export$7331e89b452882e5 = function() {
    return `
    <h3>NO PLAYERS FOUND</h3>
    <p>No results. Try a different search.</p>
    `;
};
const $5c1e54a0c01efb07$export$5891fab4c5a5fe6e = function(errMessage) {
    return `
    <h3>REQUEST ERROR</h3>
    <p>${errMessage}</p>
    `;
};
const $5c1e54a0c01efb07$export$b09058d6ad9ead68 = function() {
    return `
    <h3>NOT A VALID ENTRY</h3>
    <p>Please enter a valid value</p>
    `;
};
const $5c1e54a0c01efb07$export$cf03c0cb0e49a9ff = function() {
    return `
    <tr class="heading">
      <th>Player</th>
    </tr>
    `;
};
const $5c1e54a0c01efb07$export$d4963787bd6557de = function(playerObj) {
    return `
    <tr class="row">
      <td>
        <a
          href="./player-stats-information/player-stats-information.html?key=${playerObj.PlayerID}&team=${playerObj.Team}"
          target="_blank"
        >
          <img
            src="${playerObj.PhotoUrl}"
            alt="${playerObj.Name} photo"
          />
          <p>${playerObj.Name}</p>
        </a>
      </td>
    </tr>
    `;
};
const $5c1e54a0c01efb07$export$c5b566915199a0ab = function() {
    return `
    <tr class="heading">
      <th>Team</th>
      <th>No</th>
      <th>Pos</th>
      <th>Status</th>
      <th>Height</th>
      <th>Weight</th>
      <th>Experience</th>
    </tr>
    `;
};
const $5c1e54a0c01efb07$export$5f65794a9485272b = function(playerObj) {
    return `
    <tr class="row">
      <td>${playerObj.Team}</td>
      <td>${playerObj.Number === 0 || playerObj.Number ? playerObj.Number : "N/A"}</td>
      <td>${playerObj.Position}</td>
      <td>${playerObj.Active ? "ACT" : "NON-ACT"}</td>
      <td>${playerObj.HeightFeet}ft ${playerObj.HeightInches}in</td>
      <td>${playerObj.Weight}lbs</td>
      <td>${playerObj.ExperienceString}</td>
    </tr>
    `;
};
const $5c1e54a0c01efb07$export$579b2bba0d87046e = async function(urlAllTeams) {
    try {
        const response = await fetch(urlAllTeams);
        const allTeamsArray = await response.json();
        return allTeamsArray;
    } catch (e) {
        console.log(e);
        e.message = $5c1e54a0c01efb07$export$65d22f7a770a927c;
        return e;
    }
};
const $5c1e54a0c01efb07$export$d73096a4359f2b26 = async function(teamsArr, searchFirstName, searchLastName) {
    try {
        const teamPromises = teamsArr.map((team)=>{
            return $5c1e54a0c01efb07$export$1f483766ca50721e(`https://api.sportsdata.io/v3/nfl/scores/json/Players/${team.Key}?key=${"93fc190a9dad467fa4ac0ba550cf2e70"}`, searchFirstName, searchLastName);
        });
        const searchResults = await Promise.all(teamPromises);
        return searchResults.flat();
    } catch (e) {
        console.log(e);
        e.message = $5c1e54a0c01efb07$export$65d22f7a770a927c;
        return e;
    }
};
const $5c1e54a0c01efb07$export$c81c86d5fa45b577 = async function(teamsArr, searchString) {
    try {
        const teamPromises = teamsArr.map((team)=>{
            return $5c1e54a0c01efb07$export$cc6bd204533dda24(`https://api.sportsdata.io/v3/nfl/scores/json/Players/${team.Key}?key=${"93fc190a9dad467fa4ac0ba550cf2e70"}`, searchString);
        });
        const searchResults = await Promise.all(teamPromises);
        return searchResults.flat();
    } catch (e) {
        console.log(e);
        e.message = $5c1e54a0c01efb07$export$65d22f7a770a927c;
        return e;
    }
};
const $5c1e54a0c01efb07$export$1f483766ca50721e = async function(urlTeam, searchFirstName, searchLastName) {
    try {
        let searchResultsTeamArray = [];
        const resTeamPlayers = await fetch(urlTeam);
        const playersForTeam = await resTeamPlayers.json();
        await playersForTeam.forEach((player)=>{
            if (player.FirstName.toLowerCase() === searchFirstName.toLowerCase() && player.LastName.toLowerCase() === searchLastName.toLowerCase()) searchResultsTeamArray.push(player);
        });
        return searchResultsTeamArray;
    } catch (e) {
        console.log(e);
        e.message = $5c1e54a0c01efb07$export$65d22f7a770a927c;
        return e;
    }
};
const $5c1e54a0c01efb07$export$cc6bd204533dda24 = async function(urlTeamPlayers, searchString) {
    try {
        let searchResultsTeamArray = [];
        const resTeamPlayers = await fetch(urlTeamPlayers);
        const playersForTeam = await resTeamPlayers.json();
        await playersForTeam.forEach((player)=>{
            if (player.FirstName.toLowerCase().includes(searchString.toLowerCase()) || player.LastName.toLowerCase().includes(searchString.toLowerCase())) searchResultsTeamArray.push(player);
        });
        return searchResultsTeamArray;
    } catch (e) {
        console.log(e);
        e.message = $5c1e54a0c01efb07$export$65d22f7a770a927c;
        return e;
    }
};
const $5c1e54a0c01efb07$export$231ff8659bfc498 = function(players) {
    const photoNameContainer = document.createElement("div");
    photoNameContainer.classList.add("photo-name-container");
    const photoNameTable = document.createElement("table");
    photoNameTable.classList.add("photo-name-table");
    photoNameContainer.appendChild(photoNameTable);
    const otherPlayerInfoContainer = document.createElement("div");
    otherPlayerInfoContainer.classList.add("other-player-info-container");
    const otherPlayerInfoTable = document.createElement("table");
    otherPlayerInfoTable.classList.add("other-player-info-table");
    otherPlayerInfoContainer.appendChild(otherPlayerInfoTable);
    const playerListSectionContainer = document.createElement("div");
    playerListSectionContainer.classList.add("player-list-container");
    playerListSectionContainer.appendChild(photoNameContainer);
    playerListSectionContainer.appendChild(otherPlayerInfoContainer);
    photoNameTable.insertAdjacentHTML("afterbegin", $5c1e54a0c01efb07$export$cf03c0cb0e49a9ff());
    players.forEach((player)=>photoNameTable.insertAdjacentHTML("beforeend", $5c1e54a0c01efb07$export$d4963787bd6557de(player)));
    otherPlayerInfoTable.insertAdjacentHTML("afterbegin", $5c1e54a0c01efb07$export$c5b566915199a0ab());
    players.forEach((player)=>otherPlayerInfoTable.insertAdjacentHTML("beforeend", $5c1e54a0c01efb07$export$5f65794a9485272b(player)));
    const playerListSection = document.createElement("section");
    playerListSection.classList.add("player-list");
    playerListSection.appendChild(playerListSectionContainer);
    return playerListSection;
};


parcelRequire("eXN3h");
// Landing Page Sections
const $a7d9b78e96801c4e$var$exploreTeams = document.querySelector(".team-stats-data-btn");
const $a7d9b78e96801c4e$var$explorePlayers = document.querySelector(".player-stats-data-btn");
const $a7d9b78e96801c4e$var$infoCardsPlayerFormSection = document.querySelector(".info-cards-player-form-section");
const $a7d9b78e96801c4e$var$infoCardsContainer = document.querySelector(".info-cards-container");
const $a7d9b78e96801c4e$var$playerSearchContainer = document.querySelector(".player-search-container");
const $a7d9b78e96801c4e$var$playerSearchForm = document.querySelector("#player-search-form");
const $a7d9b78e96801c4e$var$playerSearchArea = document.querySelector("#player-search");
const $a7d9b78e96801c4e$var$playerSearchBtn = document.querySelector("#player-search-btn");
const $a7d9b78e96801c4e$var$playerSearchResultsContainer = document.querySelector(".player-search-results");
$a7d9b78e96801c4e$var$exploreTeams.addEventListener("click", function() {
    $a7d9b78e96801c4e$var$playerSearchContainer.classList.add("hidden");
    $a7d9b78e96801c4e$var$infoCardsContainer.classList.remove("hidden");
    $a7d9b78e96801c4e$var$infoCardsPlayerFormSection.classList.remove("hidden");
    $a7d9b78e96801c4e$var$infoCardsPlayerFormSection.scrollIntoView({
        behavior: "smooth"
    });
});
$a7d9b78e96801c4e$var$explorePlayers.addEventListener("click", function() {
    $a7d9b78e96801c4e$var$infoCardsContainer.classList.add("hidden");
    $a7d9b78e96801c4e$var$playerSearchForm.classList.remove("hidden");
    $a7d9b78e96801c4e$var$playerSearchContainer.classList.remove("hidden");
    $a7d9b78e96801c4e$var$infoCardsPlayerFormSection.classList.remove("hidden");
    $a7d9b78e96801c4e$var$infoCardsPlayerFormSection.scrollIntoView({
        behavior: "smooth"
    });
});
$a7d9b78e96801c4e$var$playerSearchBtn.addEventListener("click", function(e) {
    e.preventDefault();
    if ($a7d9b78e96801c4e$var$playerSearchArea.value.trim() === "") {
        $a7d9b78e96801c4e$var$playerSearchResultsContainer.innerHTML = "";
        $a7d9b78e96801c4e$var$playerSearchResultsContainer.innerHTML = (0, $5c1e54a0c01efb07$export$b09058d6ad9ead68)();
        return;
    }
    const searchEntriesArray = $a7d9b78e96801c4e$var$playerSearchArea.value.trim().split(" ");
    if (searchEntriesArray.length >= 3) {
        $a7d9b78e96801c4e$var$playerSearchResultsContainer.innerHTML = "";
        $a7d9b78e96801c4e$var$playerSearchResultsContainer.innerHTML = (0, $5c1e54a0c01efb07$export$7331e89b452882e5)();
    }
    if (searchEntriesArray.length === 2) {
        const [searchFirstName, searchLastName] = searchEntriesArray;
        (0, $5c1e54a0c01efb07$export$579b2bba0d87046e)(`https://api.sportsdata.io/v3/nfl/scores/json/Teams?key=${"93fc190a9dad467fa4ac0ba550cf2e70"}`).then((teams)=>{
            if (teams instanceof Error) throw teams;
            return (0, $5c1e54a0c01efb07$export$d73096a4359f2b26)(teams, searchFirstName, searchLastName);
        }).then((resArray)=>{
            if (resArray instanceof Error) throw resArray;
            if (resArray.length === 0) {
                $a7d9b78e96801c4e$var$playerSearchResultsContainer.innerHTML = "";
                $a7d9b78e96801c4e$var$playerSearchResultsContainer.innerHTML = (0, $5c1e54a0c01efb07$export$7331e89b452882e5)();
            } else {
                $a7d9b78e96801c4e$var$playerSearchResultsContainer.innerHTML = "";
                $a7d9b78e96801c4e$var$playerSearchResultsContainer.appendChild((0, $5c1e54a0c01efb07$export$231ff8659bfc498)(resArray));
            }
        }).catch((err)=>{
            $a7d9b78e96801c4e$var$playerSearchResultsContainer.innerHTML = "";
            $a7d9b78e96801c4e$var$playerSearchResultsContainer.innerHTML = (0, $5c1e54a0c01efb07$export$5891fab4c5a5fe6e)(err.message);
        });
    }
    if (searchEntriesArray.length === 1) {
        const [searchName] = searchEntriesArray;
        (0, $5c1e54a0c01efb07$export$579b2bba0d87046e)(`https://api.sportsdata.io/v3/nfl/scores/json/Teams?key=${"93fc190a9dad467fa4ac0ba550cf2e70"}`).then((teams)=>{
            if (teams instanceof Error) throw teams;
            return (0, $5c1e54a0c01efb07$export$c81c86d5fa45b577)(teams, searchName);
        }).then((resArray)=>{
            if (resArray instanceof Error) throw resArray;
            if (resArray.length === 0) {
                $a7d9b78e96801c4e$var$playerSearchResultsContainer.innerHTML = "";
                $a7d9b78e96801c4e$var$playerSearchResultsContainer.innerHTML = (0, $5c1e54a0c01efb07$export$7331e89b452882e5)();
            } else {
                $a7d9b78e96801c4e$var$playerSearchResultsContainer.innerHTML = "";
                $a7d9b78e96801c4e$var$playerSearchResultsContainer.appendChild((0, $5c1e54a0c01efb07$export$231ff8659bfc498)(resArray));
            }
        }).catch((err)=>{
            $a7d9b78e96801c4e$var$playerSearchResultsContainer.innerHTML = "";
            $a7d9b78e96801c4e$var$playerSearchResultsContainer.innerHTML = (0, $5c1e54a0c01efb07$export$5891fab4c5a5fe6e)(err.message);
        });
    }
});


//# sourceMappingURL=index.38ce18b6.js.map
